import React from "react";
import styled from 'styled-components'
import {FaBars} from "react-icons/fa";
import Sidebar from "./Sidebar";
import nombre from "../../img/promsalud-nombre.jpg"

const RightPanel = styled.div`
  display: flex;
  width: calc(100% - 220px);
  height: calc(100vh - 50px);
  scroll-behavior: smooth;
  margin-left: 220px;
  overflow-y: auto;
  transition: 0.5s all ease-in-out;
  @media screen and (max-width: 992px){
    transition: 0.5s all ease-in-out;
    margin-left: 0;
    width: 100%;
  }
`
const TopbarStyled = styled.div`
  height: 50px;
  background: white;
  box-shadow:0 0.125rem 9.375rem rgb(90 97 105 / 10%);
  padding: 0 16px 0 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  font-size: 1rem;
  gap:8px;
  overflow: visible;
  z-index: 10;
  transition: 0.5s all ease-in-out;
`
const MenuContainer = styled.div`
  height: 50px;
  width: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.5s all ease-in-out;
  @media screen and (max-width: 992px){
    transition: 0.5s all ease-in-out;
    width: 50px;
  }
`
const SidebarContainer = styled.aside`
  border: black solid thin;
  width: 220px;
  background: var(--sidebar);
  color: var(--sibebar-font);
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  position: fixed;
  top: 0;
  left: 0;
  transition: 0.5s all ease-in-out;
  z-index: 10;
  box-shadow: 0 0.125rem 9.375rem rgb(90 97 105 / 10%), 0 0.25rem 0.5rem rgb(90 97 105 / 12%), 0 0.9375rem 1.375rem rgb(90 97 105 / 10%), 0 0.4375rem 2.1875rem rgb(165 182 201 / 10%);

  @media screen and (max-width: 992px) {
    transition: 0.5s all ease-in-out;
    transform: translateX(-220px);
  }
`
const BackdropContainer = styled.div`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  display: block;
  z-index: 998;
  background-color: #00000080;
  visibility: ${({isOpen}) => (isOpen ? 'visible' : 'hidden')};
  transition: 0.1s all cubic-bezier(0.25, 0.8, 0.25, 1);
`
const SidebarContainerMobile = styled.aside`
  border: black solid thin;
  position: fixed;
  z-index: 999;
  width: 220px;
  height: 100%;
  background: var(--sidebar);
  color: var(--sibebar-font);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  top: 0;
  transition: 0.3s all ease-in-out;
  overflow-y: auto;
  opacity: ${({isOpen}) => (isOpen ? '100%' : '0')};
  left: ${({isOpen}) => (isOpen ? '0' : '-100%')};
`
const HeaderContainer = styled.div`
  border-width: thin;
  border-color: black;
  border-top: solid;
  border-bottom: solid;
  display: flex;
  flex-direction: row;
  align-items: center;
  //padding: 0 12px;
  height: 50px;
  gap: 8px;
  transition: 0.5s all ease-in-out;
`

const MainDashboard = ({children, topRight, toggleMobile,items, isOpen}) => {

  return (
    <div className="app">
      <TopbarStyled>
        <div style={{display: 'flex', flexDirection: 'row', flex: 1, alignItems: 'center'}}>
          <MenuContainer onClick={toggleMobile}>
            <FaBars size={18} />
          </MenuContainer>
        </div>
        {topRight}
      </TopbarStyled>
      <BackdropContainer isOpen={isOpen} onClick={toggleMobile} />
      <SidebarContainerMobile isOpen={isOpen}>
        <HeaderContainer>
          <img src={nombre} alt="logo" style={{width: '100%', height: 50}} />
        </HeaderContainer>
        <Sidebar items={items} />
      </SidebarContainerMobile>
      <SidebarContainer>
        <HeaderContainer>
          <img src={nombre} alt="logo" style={{width: '100%', height: 50}} />
        </HeaderContainer>
        <Sidebar items={items} />
      </SidebarContainer>

      <RightPanel>
        {children}
      </RightPanel>

    </div>
  )
};

export default MainDashboard;
